/**
 * Иконки, нужные только этому приложению.
 *
 * Общий набор — `IconCollection` из `@aspid/ui`; здесь лежит то, что на момент
 * сведения (AF-19) встречалось лишь у applications, и осознанные оверрайды общих имён.
 *
 * **Добавить иконку — одна строка здесь.** Правок в пакете не требуется: если
 * иконка понадобится второму приложению, тогда и переедет в общий набор.
 */

import {
  faCheckToSlot as checkSlot,
  faXmark as cross,
  faCircleExclamation as errorOutline,
  faCircleInfo as infoOutlined,
  faTriangleExclamation as warning,
} from '@fortawesome/pro-light-svg-icons';
import {
  faCaretDown as caretDown,
  faCircleCheck as doneSolid,
  faCircleSmall as dotSolid,
  faCircleExclamation as errorSolid,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faBan as banThin,
  faCheckToSlot as checkSlotThin,
} from '@fortawesome/pro-thin-svg-icons';

export const appIcons = {
  banThin,
  caretDown,
  checkSlot,
  checkSlotThin,
  cross,
  doneSolid,
  dotSolid,
  errorOutline,
  errorSolid,
  infoOutlined,
  warning,
};
